import { useMemo } from 'react';
import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useSingleOperation from '../useSingleOperation';
import { getOperationViewSections } from '../operationViewSections';

const ViewSection = ({ title, fields }) => (
  <List
    header={<div>{title}</div>}
    style={{ marginTop: 24 }}
    dataSource={fields}
    renderItem={(item) => (
      <List.Item>
        <b className={styles.itemName}>{item.text}</b>
        {item.value}
      </List.Item>
    )}
  />
);

const SingleOperation = () => {
  const { t } = useTranslation();
  const { singleItem, loading, facilityTypes, statuses } = useSingleOperation();

  const sections = useMemo(
    () =>
      getOperationViewSections(t, singleItem, { facilityTypes, statuses }),
    [t, singleItem, facilityTypes, statuses],
  );

  const pageTitle =
    facilityTypes?.[singleItem?.facility_type] || t('INTERVENTO FACILITY');

  const showEdit = singleItem?.can_update || singleItem?.can_approve;

  return (
    <div>
      <PageHeader title={pageTitle} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          {sections.map((section) => (
            <ViewSection
              key={section.title}
              title={section.title}
              fields={section.fields}
            />
          ))}
        </Spin>
        <Divider />
        <Row gutter={16}>
          {showEdit && (
            <Col>
              <Button>
                <Link to={`/facility/operations/${singleItem?.id}/edit`}>
                  {t('MODIFICA')}
                </Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={'/facility/operations'}>{t('TORNA INDIETRO')}</Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SingleOperation;
